// extracted by mini-css-extract-plugin
module.exports = {"quantityBtn":"quantityBtn--3np-9","quantityInput":"quantityInput--3e0Qn"};